import React, { Component } from 'react';
import { connect } from 'react-redux';

import DetailsFields from './components/DetailsFields';
import ExecutionFields from './components/ExecutionFields';
import ResultsTable from './components/ResultsTable';

import materialTabService from "@services/requests/material-tab.service";

import { 
  setMasonryJobSiteTestDesignation, 
  setMasonryJobSiteTestName,
  setMasonryJobSiteTestSize 
} from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../../../texts/texts';

const TABS = {
  DETAILS: 'DETAILS',
  EXECUTION: 'EXECUTION',
  RESULTS: 'RESULTS'
};

class JobSiteTest extends Component {

  state = {
    tab: TABS.DETAILS,
    products: [],
    sizes: []
  };

  componentDidMount() {
    this.getMasonryProducts();
  }

  render() {
    return (
      <div>
        <div className="list-type row ml-0 mr-0">
          <div className="col-6">
            <h4>{APP_TEXTS.PRODUCT_TESTED_NAME_LABEL.Content}</h4>
            <label htmlFor="name" className="d-flex justify-content-between align-items-center">
              <select className="form-control col-10" id="name"
                value={this.props.name}
                onChange={({ target }) => {
                  this.props.setName(target.value);
                  this.props.setSize("");
                  this.getMasonrySizes(target.value);
                }}
              >
                <option value="">{APP_TEXTS.ANCHOR_SELECTION_ALL_PRODUCTS.Content}</option>
                {this.state.products.map(product => (
                  <option value={product.InternalName} key={product.InternalName}>
                    {product.RunName}
                  </option>
                ))}
              </select>
            </label>
            
            <h4 className="mt-2">{APP_TEXTS.SIZE_LABEL.Content}</h4>
            <label htmlFor="size" className="d-flex justify-content-between align-items-center">
              <select className="form-control col-10" id="size"
                value={this.props.size}
                onChange={({ target }) => this.props.setSize(target.value)}
              >
                <option value="">{APP_TEXTS.ALL_DIMENSIONS.Content}</option>
                {this.state.sizes.length > 0 && this.state.sizes.map(size => (
                  <option value={size.InternalName} key={size.InternalName}>
                    {size.RunName}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="col-6">
            <h4>{APP_TEXTS.DESIGNATION_OF_MASONRY_LABEL.Content}</h4>
            <label htmlFor="designation-of-masonry" className="d-flex justify-content-between align-items-center">
              <input className="form-control col-10" type="text" id="designation-of-masonry" maxLength={50}
                value={this.props.designation}
                onChange={({ target }) => this.props.setDesignation(target.value)}
              />
            </label>
          </div>
        </div>

        <div className="calculation design-and-combined-loading">
          <div className="list-type">
            <nav className="btn-group">
              <button
                className={`btn ${this.state.tab === TABS.DETAILS && "ToggleButton--active"}`}
                onClick={() => this.setState({ tab: TABS.DETAILS })}
              >
               {APP_TEXTS.DETAILS.Content}
              </button>

              <button
                className={`btn ${this.state.tab === TABS.EXECUTION && "ToggleButton--active"}`}
                onClick={() => this.setState({ tab: TABS.EXECUTION })}
              >
                {APP_TEXTS.EXECUTION.Content}
              </button>

              <button
                className={`btn ${this.state.tab === TABS.RESULTS && "ToggleButton--active"}`}
                onClick={() => this.setState({ tab: TABS.RESULTS })}
              >
                {APP_TEXTS.RESULTS.Content}
              </button>
            </nav>
          </div>

          {this.state.tab === TABS.DETAILS && (
            <div className="list-type">
              <DetailsFields />
            </div>
          )}
          {this.state.tab === TABS.EXECUTION && (
            <div className="list-type">
              <ExecutionFields />
            </div>
          )}
          {this.state.tab === TABS.RESULTS && (
            <div className="list-type">
              <ResultsTable />
            </div>
          )}
        </div>
      </div>
    );
  }

  getMasonryProducts = () => {
    materialTabService.getMasonryProducts().then(res => {
      if (res) {
        this.setState({
          products: res
        });
      }
    });
  }

  getMasonrySizes = (product) => {
    materialTabService.getMasonrySizes(product).then(res => {
      if (res) {
        this.setState({
          sizes: res
        });
      }
    });
  }

}

const mapState = state => ({
  name: state.selectors.material[state.main.appType].masonry.jobSiteTest.productName,
  size: state.selectors.material[state.main.appType].masonry.jobSiteTest.size,
  designation: state.selectors.material[state.main.appType].masonry.jobSiteTest.designation,
  temperatureUnit: state.main.units.temperature,
  loadUnit: state.main.units.load,
  strengthUnit: state.main.units.strength,
  distanceUnit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  setName: value => dispatch(setMasonryJobSiteTestName(value)),
  setSize: value => dispatch(setMasonryJobSiteTestSize(value)),
  setDesignation: value => dispatch(setMasonryJobSiteTestDesignation(value)),
});

export default connect(mapState, mapDispatch)(JobSiteTest);



// WEBPACK FOOTER //
// ./src/views/Material/components/Masonry/components/JobSiteTest/index.js